import React, { ReactNode, useRef } from "react";
import { Box, Flex, Icon, css } from "@storyofams/react-ui";
import styled from "styled-components";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import useMediaQuery from "~hooks/useMediaQuery";
import { WhiteLink, WhiteLinkLeft } from "../Icons";

export type SliderProps = {
  children: ReactNode[];
  centerInsufficientSlides?: boolean;
  spaceBetween?: number;
  initialSlide?: number;
  small?: boolean;
  isReview?: boolean;
  isNavigationCentered?: boolean;
};
export const GallerySlider = ({
  children,
  centerInsufficientSlides,
  spaceBetween,
  initialSlide = 0,
  small = false,
  isReview = false,
  isNavigationCentered = false,
  ...props
}: any) => {
  const swiperRef = useRef(null);
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  return (
    /* purgecss ignore */
    <>
      <Flex
        variant="center"
        position={"relative"}
        overflow={"visible"}
        css={css({
          width: "100%",
        })}
      >
        <Container className="slider-container">
          <Swiper
            /* purgecss ignore */
            slidesPerView="auto"
            onInit={(core) => {
              swiperRef.current = core.el;
            }}
            className="mySwiper"
            // centeredSlides={matchesMobile}
            overflow="visible"
            initialSlide={initialSlide}
            modules={[Navigation]}
            pagination={{
              dynamicBullets: true,
            }}
            spaceBetween={spaceBetween || 12}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
              disabledClass: "swiper-button-disabled",
            }}
            direction="horizontal"
            mousewheel={false}
            // centeredSlidesBounds={matchesMobile}
            watchOverflow
            // centerInsufficientSlides={centerInsufficientSlides || matchesMobile}
            breakpoints={{
              // when window width is >= 320px
              767: {
                spaceBetween: spaceBetween || 12,
              },
            }}
            {...props}
          >
            {children &&
              children?.map((child, index) => (
                <SwiperSlide key={String(index)}>{child}</SwiperSlide>
              ))}
            <NavigationButton />
            <NavigationButton direction="next" />
          </Swiper>
        </Container>
      </Flex>
    </>
  );
};

export const NavigationButton = ({ direction = "prev" }) => (
  <Box
    minWidth={"40px !important"}
    width="40px !important"
    height="40px"
    className={`swiper-button-${direction}`}
  >
    <Icon
      icon={direction === "prev" ? WhiteLinkLeft : WhiteLink}
      fontSize={5}
      color="black"
      css={{
        // transform: `rotate(${direction === "prev" ? "180deg" : "0deg"})`,
        filter: `drop-shadow(${
          direction === "prev" ? "2px" : "-2px"
        } 3px 2px rgb(0 0 0 / 0.2))`,
        borderRadius: "50%",
      }}
    />
  </Box>
);

const Container = styled.div`
  width: 100%;
  overflow: visible;
  .swiper-button-next,
  .swiper-button-prev {
    top: 50%;
    &:after {
      content: unset;
    }
  }
  .swiper-button-prev {
    left: -12px;
  }
  .swiper-button-next {
    right: -12px;
  }
  .swiper-wrapper {
    overflow: visible;
  }
  .swiper-button-disabled {
    display: none;
  }
  .swiper {
    overflow: visible;
  }
`;
